import { render } from "./detail.vue?vue&type=template&id=cae6e6a4&ts=true"
import script from "./detail.vue?vue&type=script&lang=ts&config=true"
export * from "./detail.vue?vue&type=script&lang=ts&config=true"

import "./detail.vue?vue&type=style&index=0&id=cae6e6a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__